var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseSmallBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_25315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_25315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4L9.08327 16.325C8.89877 16.5084 8.66402 16.6 8.37902 16.6C8.09402 16.6 7.85936 16.5084 7.67502 16.325C7.49169 16.1417 7.40002 15.9084 7.40002 15.625C7.40002 15.3417 7.49169 15.1084 7.67502 14.925L10.6 12L7.67502 9.1083C7.49169 8.9238 7.40002 8.68905 7.40002 8.40405C7.40002 8.11905 7.49169 7.88438 7.67502 7.70005C7.85836 7.51672 8.09169 7.42505 8.37502 7.42505C8.65836 7.42505 8.89169 7.51672 9.07502 7.70005L12 10.625L14.8918 7.70005C15.0763 7.51672 15.311 7.42505 15.596 7.42505C15.881 7.42505 16.1157 7.51672 16.3 7.70005C16.5 7.90005 16.6 8.13755 16.6 8.41255C16.6 8.68755 16.5 8.91672 16.3 9.10005L13.375 12L16.3 14.9168C16.4834 15.1013 16.575 15.336 16.575 15.621C16.575 15.906 16.4834 16.1407 16.3 16.325C16.1 16.525 15.8625 16.625 15.5875 16.625C15.3125 16.625 15.0834 16.525 14.9 16.325L12 13.4Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSmallBlue);
export default __webpack_public_path__ + "static/media/icon_close_small_blue.7dd933662217ea02fe16a268879dbd95.svg";
export { ForwardRef as ReactComponent };